/**
 * `42429` — *archive item*. Confirmed as a real monday block by the catalogue capture: static
 * recipes `15` and `200` map to `223025 → 42429` and `580 → 42429`
 * (`discovery/automations/api/static-recipe-mapping.md`).
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
export const archiveItemParams = z.object({});
export const archiveItemAction = defineAction({
    id: '42429',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'archive item',
    paramsSchema: archiveItemParams,
    executable: true,
    references: () => [],
    async execute(context) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const item = await context.services.getItem(context.itemId);
        if (item === null || item.state !== 'active')
            return { skipped: 'item_deleted' };
        await context.services.archiveItem(context.itemId);
        return { itemId: context.itemId, archived: true };
    },
});
//# sourceMappingURL=42429.js.map